export enum PredefinedData { FALSE, READONLY, UPDATEONLY }

export const deletableCallback = (item: any) => {
    return item.predefinedData === PredefinedData.UPDATEONLY  || item.predefinedData === PredefinedData.READONLY;
};

export const editableCallback = (item: any, editForm: boolean) => {
    return !editForm || (item.predefinedData === PredefinedData.UPDATEONLY  || item.predefinedData === PredefinedData.FALSE);
};
